import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { camelCaseToTextWithSpace } from '@/utils/camelCaseToTextWithSpace';
import { useShallow } from 'zustand/react/shallow';

export const useStripeElements = () => {
  const { add, cardName, errorsPayment, removeError, setError } = usePrenuvoStore(
    useShallow((state) => ({
      add: state.payment.methods.add,
      cardName: state.payment.cardName,
      removeError: state.payment.methods.removeError,
      errorsPayment: state.payment.errors,
      setError: state.payment.methods.setError,
    })),
  );

  const handleChange = (value: string) => {
    add({ cardName: value });
  };

  const handleStripeElementError = ({
    error,
    field,
    complete,
  }: {
    error: any;
    field: string;
    complete?: boolean;
  }) => {
    removeError(field);
    if (!complete && !error)
      setError(field, `Your ${camelCaseToTextWithSpace(field)} is incomplete.`);
    if (error?.message) setError(field, error.message);
  };

  return { cardName, errorsPayment, add, removeError, handleChange, handleStripeElementError };
};
